import React from "react"

import FieldRAG_Icon from "../../../../../generic/rag/components/rag-icon"
import {ColorPalette} from "../../../../../color-coding/color-coding";

export default function FieldGoalHealth_InlineValueNotEmpty(props:any) {

    const onDeleteClick = () => {
        props.onChange(null)
    }

    const style = {
        color           : gd.skin.colors.mainColor({
            colorNumber     : props.option?.color,
            corePalette     : ColorPalette.SYSTEM
        })
    }

    return (
        <React.Fragment>
            <div className={Classes("ui5-field-with-delete-on-hover", props.className)}>
                <div className="ui5-field-dropdown-inline-editable w-100-percent with-delete txt-truncate" onClick={props.onClick}>
                    <FieldRAG_Icon className="fl-ac m-r-5" option={props.option}/>
                    <div className="ui5-txt-default txt-truncate"
                         style={style}>
                        {props.option?.label}
                    </div>
                </div>

                {props.field.clearButton && <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>}
            </div>
            {props.children}
        </React.Fragment>
    )
}